import { createAction, props } from '@ngrx/store';
import { SystemPresence } from '../models/system-presence.model';
import { withGenesysCloudStoreNameSpace } from '../../common/action-namespace';

const withNameSpace = withGenesysCloudStoreNameSpace('Presence');

export const initializeModule = createAction(
  withNameSpace('Initialize module')
);

export const updatePresence = createAction(
  withNameSpace('Update presence'),
  props<{ systemPresenceId: string }>()
);

export const togglePresence = createAction(
  withNameSpace('Toggle presence')
);

export const updatePresenceSuccess = createAction(
  withNameSpace('Update presence success'),
  props<{ systemPresenceId: string }>()
);

export const loadSystemPresences = createAction(
  withNameSpace('Load System Presences')
);

export const systemPresencesLoaded = createAction(
  withNameSpace('System Presences loaded'),
  props<{ systemPresences: SystemPresence[] }>()
);

export const getActualPresence = createAction(
  withNameSpace('Get actual presence')
);
export const getActualPresenceSuccess = createAction(
  withNameSpace('Get actual presence success'),
  props<{ systemPresenceId: string }>()
);
